import Vue from "vue";
import store from "./store";
import "../../assets/css/global.less";
import "../../assets/css/theme.less";
import service from "./service";
import customerConstant from "./constant";
import "reset.css";
import "./global";
import SvgIcon from "vue-svgicon";
import "../../../src/icons";

import utils from "../../utils";
import mobileApp from "./mobile/app.vue";
import desktopApp from "./desktop/app.vue";
import createMobileRouter from "./mobile/router";
import createDesktopRouter from "./desktop/router";

Vue.use(SvgIcon, {
  tagName: "svgicon"
});

const isH5 = process.env.VUE_APP_DEVICE === "h5";
//引入svg-icon
const isMobileFlag = isH5 || utils.isMobile();
const platformApp = isMobileFlag ? mobileApp : desktopApp;
const platformRouter = isMobileFlag ? createMobileRouter : createDesktopRouter;
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);
Vue.config.productionTip = false;
Vue.prototype.$service = service;
Vue.prototype.$customerConstant = customerConstant;
Vue.prototype.eventBus = new Vue();

export const initVue = () => {
  return new Promise(resolve => {
    platformRouter().then(router => {
      const vm = new Vue({
        router,
        store,
        render: h => h(platformApp)
      }).$mount("#app");
      resolve({
        router,
        store,
        vm
      });
    });
  });
};
